// Shared ordering for the assessment-comparison screens. The comparison always presents the most
// recent version as "Version 1" / series A (top) across labels, legend, charts and tables, so the
// two selected versions are normalised newest-first at navigation time and the canonical vaId/vbId
// in the URL then drives every surface consistently.
//
// The live/[CURRENT] state is identified by a null / undefined / 'null' id and is always treated as
// the newest (it is the still-evolving live assessment, newer than any published snapshot).

export const isCurrentVersionId = (id?: string | null): boolean => !id || id === 'null';

export const versionCreatedAtTime = (createdAt?: string | number | null): number => {
  if (!createdAt) return 0;
  const time = new Date(createdAt).getTime();
  return Number.isNaN(time) ? 0 : time;
};

// Returns [vaId, vbId] ordered newest-first. `getCreatedAt` resolves a (real) version id to its
// creation timestamp; [CURRENT] selections skip the lookup and sort to the top.
export const orderVersionIdsNewestFirst = <T extends string | null | undefined>(
  idA: T,
  idB: T,
  getCreatedAt: (id: string) => string | number | null | undefined,
): [T, T] => {
  const timeOf = (id?: string | null): number =>
    isCurrentVersionId(id) ? Number.POSITIVE_INFINITY : versionCreatedAtTime(getCreatedAt(id as string));

  return timeOf(idB) > timeOf(idA) ? [idB, idA] : [idA, idB];
};
